module.exports = __webpack_public_path__ + "static/media/newToTTC.1f86285c.svg";